(() => {
  const button = document.querySelector('[data-product-back]');
  if (!button) return;

  button.addEventListener('click', () => {
    const referrer = document.referrer;
    const cameFromStore = referrer && new URL(referrer, window.location.origin).origin === window.location.origin;

    if (cameFromStore && window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.assign(button.dataset.backFallback || '/');
  });
})();
